import { orderConstants } from '../constants';

export function order(state = {}, action) {
  switch (action.type) {
    case orderConstants.GET_ORDER_REQUEST:
      return {
        loading: true
      };
    case orderConstants.GET_ORDER_SUCCESS:
      return {
        ...state, order: action.data
      }
    case orderConstants.GET_ORDER_FAILURE:
      return {
        error: action.error
      };
    case orderConstants.GET_ORDERS_REQUEST:
      return {
        loading: true
      };
    case orderConstants.GET_ORDERS_SUCCESS:
      return {
        ...state, orders: action.data
      }
    case orderConstants.GET_ORDERS_FAILURE:
      return {
        error: action.error
      };
    case orderConstants.UPDATE_ORDER_REQUEST:
      return {
        loading: true
      };
    case orderConstants.UPDATE_ORDER_SUCCESS:
      return {
        item: action.order
      };
    case orderConstants.UPDATE_ORDER_FAILURE:
      return {
        error: action.error
      };
    case orderConstants.UPLOAD_FILE_ORDER_REQUEST:
      return {
        loading: true
      };
    case orderConstants.UPLOAD_FILE_ORDER_SUCCESS:
      return {
        ...state
      };
    case orderConstants.UPLOAD_FILE_ORDER_FAILURE:
      return {
        ...state, uploaderror: action.error
      };
    default:
      return state
  }
}
